var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "2px",
    viewBox: "0 0 4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CheckboxCheck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instellingen---Functies---Mobiele-app---Instellingen",
    transform: "translate(-445.000000, -781.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CheckboxChecked",
    transform: "translate(442.000000, 777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CheckboxCheck",
    transform: "translate(3.000000, 3.500000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 1.5,
    x2: 1.5,
    y2: 2.5,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 2.5,
    x2: 3.5,
    y2: 0.5,
    id: "Line-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheck);
export default __webpack_public_path__ + "static/media/CheckboxCheck.5344fdf19a084d2b7b248b569676beb5.svg";
export { ForwardRef as ReactComponent };